import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgShareExternalLink = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 24 24",
	height: "1em",
	width: "1em",
	...props,
	children: [
		/* @__PURE__ */ _jsx("line", {
			x1: 9.25,
			y1: 14.523,
			x2: 23.25,
			y2: .75,
			stroke: "var(--icon-color, currentColor)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: 1.5,
			fill: "none"
		}),
		/* @__PURE__ */ _jsx("polyline", {
			points: "23.25 8.621 23.25 0.75 15.25 0.75",
			stroke: "var(--icon-color, currentColor)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: 1.5,
			fill: "none"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M12.125,5.75H1.625a.875.875,0,0,0-.875.875v15.75a.875.875,0,0,0,.875.875h15.75a.875.875,0,0,0,.875-.875v-10.5",
			stroke: "var(--icon-color, currentColor)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: 1.5,
			fill: "none"
		})
	]
});
export default SvgShareExternalLink;
